import { Injectable } from '@angular/core';
import { EstadoPagoDTO } from 'src/app/pago/dtos/EstadoPagoDTO';
import { Pago } from 'src/app/pago/models/Pago.model';

@Injectable({
  providedIn: 'root',
})
export class EstadoPagoFactory {
  convertToModel(estadoPagoDTO: EstadoPagoDTO): Pago {
    return {
      ...estadoPagoDTO.pago,
    };
  }
}
